export enum AssignmentType {
  CURRICULUM = "CURRICULUM",
  ASSESSMENT = "ASSESSMENT",
  INSTRUCT = "INSTRUCT",
}
